import React from 'react';
import './ButtonNav.scss';
import DownloadBtn from '../DownloadBtn/DownloadBtn'; 


const ButtonNav = ({ menuItems = [], showDownloadBtnInMenu = true }) => {
  return (
    <label className="event-wrapper">
      <input type="checkbox" className="event-wrapper-inp" />
      <div className="bar">
        <span className="top bar-list"></span>
        <span className="middle bar-list"></span>
        <span className="bottom bar-list"></span>
      </div>
      <section className="menu-container">
        {menuItems.map(item => (

          <div className="menu-list" key={item.id || item.label}>
            <a href={item.href}>{item.label}</a>
          </div>
        ))}
        {showDownloadBtnInMenu && (
          
          <div className="menu-list menu-list-download-btn-container">
            <DownloadBtn
              specificClassName="button-mobile-menu-download" 
              svgHeight="30" 
              svgWidth="30"
            />
          </div>
        )}
      </section>
    </label>
  );
};

export default ButtonNav;